import React from 'react';

interface FilterProps {
  label: string;
  value: string | string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  options?: string[];
  multiple?: boolean;
}

const FilterComponent: React.FC<FilterProps> = ({ label, value, onChange, options, multiple }) => {
  return (
    <div className="filter-select">
      <label>
        {label}:
        {options ? (
          <select
            multiple={multiple}
            value={value}
            onChange={(e) => onChange(e as React.ChangeEvent<HTMLSelectElement>)}
          >
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="date"
            value={value}
            onChange={onChange}
          />
        )}
      </label>
    </div>
  );
};

export default FilterComponent;